import '../static/Paragraph.css';
import React__default, { forwardRef } from "react";
import clsx from "clsx";
import { a as RichText } from "./RichText.Dek7-xX-.mjs";
const paragraph = `_paragraph_b9747f5`;
const sizexs = `_sizexs_4a3c3f1`;
const sizemd = `_sizemd_f135bb1`;
const sizesm = `_sizesm_464b2cc`;
const sizelg = `_sizelg_f10aaac`;
const regular = `_regular_f24faf5`;
const semibold = `_semibold_148eb45`;
const bold = `_bold_dca2aef`;
const styleParagraph = { paragraph, sizexs, sizemd, sizesm, sizelg, regular, semibold, bold };
const PARAGRAPH_SIZE_VARIANTS = ["lg", "md", "sm", "xs"];
const PARAGRAPH_WEIGHT = ["regular", "semibold", "bold"];
const ParagraphInner = ({ as = "p", children, className, size = "md", weight = "regular", ...props }, ref) => {
  return /* @__PURE__ */ React__default.createElement(
    RichText,
    {
      as,
      ref,
      className: clsx(
        styleParagraph.paragraph,
        styleParagraph[`size${size}`],
        styleParagraph[weight],
        className
      ),
      "data-ui-paragraph": true,
      ...props
    },
    children
  );
};
const Paragraph = forwardRef(
  ParagraphInner
);
export {
  PARAGRAPH_SIZE_VARIANTS as P,
  PARAGRAPH_WEIGHT as a,
  Paragraph as b,
  styleParagraph as s
};
//# sourceMappingURL=Paragraph.DAcb0zW2.mjs.map
